<div class="menu-popup-container" @popupAnimation>
  <div class="menu-overlay"></div>
  <div class="menu-content">
    <a routerLink="/"><h1>{{ 'home' | translate }}</h1></a>
    <a routerLink="/Gallery"><h1>{{ 'gallery' | translate }}</h1></a>
    <a routerLink="/Events"><h1>{{ 'events' | translate }}</h1></a>
    <a routerLink="/Contact"><h1>{{ 'contact' | translate }}</h1></a>
    <a routerLink="/About"><h1>{{ 'about' | translate }}</h1></a>
    <a routerLink="/Market"><h1>Market</h1></a>
  </div>
</div>
